import i18n from '@/lang/i18n'

export default [{
  path: '/admin/apply/files/list',
  name: 'filesList',
  component: () => import('@/views/apply/files/list'),
  meta: {
    title: i18n.t('router.files.files_list'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/files/config',
  name: 'filesConfig',
  component: () => import('@/views/apply/files/config'),
  meta: {
    title: i18n.t('router.files.files_setting'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/files/detail',
  name: 'filesDetail',
  component: () => import('@/views/apply/files/detail'),
  meta: {
    title: i18n.t('router.files.files_detail'),
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/files.js